import React, { Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Link as ScrollLink, Element } from 'react-scroll'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'

const PrerollSection = ({
	first,
	last,
	classes,
	copySections,
	section,
	nextSection
}) => {
	return (
		<Fragment>
			{!first && (
				<div>
					<div className={classes.spacer} />
					<Element className={classes.element} name={section} />
				</div>
			)}
			<Paper className={classes.root} elevation={3}>
				{copySections.map((section, index) => (
					<Fragment key={index}>{section}</Fragment>
				))}
				{!last && (
					<ScrollLink
						activeClass={'activeContent'}
						smooth={true}
						duration={1000}
						to={nextSection}
					>
						<Button color={'primary'}>Next section</Button>
					</ScrollLink>
				)}
			</Paper>
		</Fragment>
	)
}

export default withStyles(theme => ({
	spacer: {
		padding: '300px 0',
		[theme.breakpoints.down('xs')]: {
			padding: '200px 0'
		}
	},
	element: {
		marginBottom: '25vh',
		[theme.breakpoints.down('xs')]: {
			marginBottom: '15vh'
		}
	},
	root: {
		...theme.mixins.gutters(),
		padding: '40px 0px'
	}
}))(PrerollSection)
